<template>
  <section class="ai-assistant-page">
    <div class="assistant-shell">
      <p class="eyebrow">Kokeellinen Raviremmi-apuri</p>
      <h1>Kysy Raviremmin datasta</h1>
      <p class="lead">
        Apuri tulkitsee kysymyksen tekoälyllä, hakee faktat Raviremmin omasta datasta ja vastaa niiden perusteella.
        Se on kokeellinen ja toimii parhaiten pisteisiin, hevosiin, ohjastajiin ja remmeihin liittyvissä kysymyksissä.
      </p>

      <div v-if="!checked" class="access-state">Tarkistetaan käyttöoikeutta...</div>
      <AiAssistantPanel v-else-if="allowed" />
      <div v-else class="access-state denied">
        Raviremmi-apuri ei ole käytössä tällä tunnuksella.
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue';
import { Auth } from 'aws-amplify';
import AiAssistantPanel from './AiAssistantPanel.vue';
import { isAiAssistantAllowed } from '../utils/aiAccess';

export default {
  name: 'AiAssistantPage',
  components: { AiAssistantPanel },
  setup() {
    const checked = ref(false);
    const allowed = ref(false);

    onMounted(async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        allowed.value = isAiAssistantAllowed({
          playerId: user.attributes?.['custom:player_id'] || user.attributes?.sub,
          username: user.attributes?.preferred_username || user.username || user.attributes?.email,
        });
      } catch (_error) {
        allowed.value = false;
      } finally {
        checked.value = true;
      }
    });

    return { checked, allowed };
  },
};
</script>

<style scoped>
.ai-assistant-page {
  color: #e6f1ff;
}

.assistant-shell {
  border: 1px solid rgba(100, 255, 218, 0.18);
  border-radius: 18px;
  background:
    radial-gradient(circle at top right, rgba(255, 198, 92, 0.12), transparent 34%),
    linear-gradient(135deg, #0a192f 0%, #112240 100%);
  box-shadow: 0 18px 48px rgba(2, 12, 27, 0.32);
  padding: 24px;
}

.eyebrow {
  margin: 0 0 8px;
  color: #ffc65c;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  color: #64ffda;
  font-size: clamp(1.85rem, 4vw, 2.7rem);
  line-height: 1.08;
}

.lead {
  max-width: 820px;
  margin: 14px 0 22px;
  color: #b7c6dc;
  line-height: 1.65;
}

.access-state {
  border: 1px dashed rgba(100, 255, 218, 0.24);
  border-radius: 16px;
  padding: 20px;
  color: #b7c6dc;
  background: rgba(10, 25, 47, 0.58);
}

.access-state.denied {
  color: #ffb4a8;
  border-color: rgba(255, 180, 168, 0.32);
}

@media (max-width: 640px) {
  .assistant-shell {
    padding: 18px;
  }
}
</style>
